import {
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_SUCCESS,
  SIGN_IN,
  SIGN_IN_SUCCESS,
  MFA_AUTHENTICATION,
  MFA_SUCCESS,
  SIGN_IN_MFA,
  TRANSACTION_TYPE,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  CHANGE_PASSWORD,
} from './types';

export const createAccount = (username, email, password, phone, description, navigation, t) => (
  {
    type: CREATE_ACCOUNT,
    payload: {username, email, password, phone, description, navigation, t},
  }
);

export const createAccountSuccess = () => (
  {
    type: CREATE_ACCOUNT_SUCCESS,
  }
);

export const signIn = (data) => (
  {
    type: SIGN_IN,
    payload: { data },
  }
);

export const signInSuccess = (data) => (
  {
    type: SIGN_IN_SUCCESS,
    payload: data,
  }
);

export const signInMFA = (data) => (
  {
    type: SIGN_IN_MFA,
    payload: data,
  }
);

export const mfaAuthentication = (data) => (
  {
    type: MFA_AUTHENTICATION,
    payload: data,
  }
);

export const mfaSuccess = (data) => (
  {
    type: MFA_SUCCESS,
    payload: data ,
  }
);

export const transactionType = (data) => (
  {
    type: TRANSACTION_TYPE,
    payload: data ,
  }
);

export const forgetPassword = (data) => (
  {
    type: FORGET_PASSWORD,
    payload: data,
  }
);

export const forgetPasswordSuccess = (data) => (
  {
    type: FORGET_PASSWORD_SUCCESS,
    payload: data,
  }
);

export const changePassword = (data) => (
  {
    type: CHANGE_PASSWORD,
    payload: data,
  }
);
